import React from "react";

import "./alarms_notifications_icon.scss";

const AlarmsNotificationsIcon = () => (
  <svg
    id="notification_Pale_White"
    data-name="notification Pale White"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    className="alarms-notifications-icon"
  >
    <rect id="uuid-83c77574-46e4-4751-8fe1-64c770c89f60" data-name="Margin" className="cls-1" width="32" height="32" />
    <path
      id="uuid-3d4425ba-4b32-434c-ac62-26cb13dcd47d"
      data-name="Bell Bottom"
      className="cls-2"
      d="M16,24c-.9,0-1.7-.6-2-1.5h4c-.3,.9-1.1,1.5-2,1.5Z"
    />
    <g id="uuid-1da66603-0c64-4717-8602-51b3232f5db2" data-name="Bell" className="cls-3">
      <path
        className="cls-2"
        d="M16,8c-.68,0-1.4,.2-1.4,.2-2.6,.6-4.2,2.9-4.2,5.9v6.3l-1.3,1.3h13.8l-1.3-1.3v-6.3c0-3-1.6-5.3-4.2-5.9,0,0-.72-.2-1.4-.2Z"
      />
    </g>
    <g id="uuid-856793ef-602c-431f-b473-43a28ec0b1dd" data-name="Bell Outline">
      <path
        className="cls-2"
        d="M16,9c.53,0,1.13,.16,1.18,.17,2.11,.49,3.42,2.37,3.42,4.93v6.6H11.4v-6.6c0-2.55,1.31-4.44,3.47-4.94,0,0,.6-.16,1.13-.16m0-1c-.68,0-1.4,.2-1.4,.2-2.6,.6-4.2,2.9-4.2,5.9v6.3l-1.3,1.3h13.8l-1.3-1.3v-6.3c0-3-1.6-5.3-4.2-5.9,0,0-.72-.2-1.4-.2h0Z"
      />
    </g>
  </svg>
);

export default AlarmsNotificationsIcon;
